'use strict';

module.exports = 'enhance';


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/ENHANCEMENTS_FLAG.js
// module id = 65
// module chunks = 0